import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';

import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { OwnerEnum } from '@shared/enums/owner.enum';
import { ownerObjectUpdater, uniqueNameValidator, validateFormGroup } from '@shared/utils/form.util';


@Component({
  selector: 'app-add-portfolio-modal',
  templateUrl: './add-portfolio-modal.component.html'
})
export class AddPortfolioModalComponent implements OnInit, OnDestroy {
  @Input() loading: boolean;
  @Input() mode: 'edit' | 'add';
  @Input() data;
  @Input() type: 'product' | 'component';
  @Input() title: string;
  @Input() users: User.UserModel[];
  @Input() teams: Team.TeamModel[];
  @Input() product?: ProductPortfolio.ProductModel[];
  @Input() components?: ComponentPortfolio.ComponentModel[];
  @Input() items?: ItemPortfolio.ItemModel[];

  ownerEnum = OwnerEnum;
  selectedUserAndTeams = {
    [this.ownerEnum.USER]: [],
    [this.ownerEnum.USER]: []
  };

  addPortfolioForm: FormGroup;

  constructor(private fb: FormBuilder,
              private customEventService: CustomEventService) { }

  ngOnInit() {
    this.createForm();
  }

  createForm(): void {
    const { id, name, description, labels, owners = [], components = [], items = [] } = this.data;

    if (owners && owners.length) {
      owners.forEach(item => {
        this.selectedUserAndTeams[item.type] = item.ids;
      });
    }

    this.addPortfolioForm = this.fb.group({
      id: [id, []],
      name: [name, [Validators.required, uniqueNameValidator(this.type === 'product' ? this.product : this.components, this.data)]],
      description: [description, []],
      labels: [labels],
      users: [this.selectedUserAndTeams[this.ownerEnum.USER], []],
      teams: [this.selectedUserAndTeams[this.ownerEnum.TEAM], []]
    });

    if (this.type === 'product') {
      this.addPortfolioForm.addControl('components', new FormControl(components.map(item => item.id)));
    } else {
      this.addPortfolioForm.addControl('items', new FormControl(items.map(item => item.id)));
    }
  }

  submitForm(): void {
    validateFormGroup(this.addPortfolioForm);

    if (this.addPortfolioForm.invalid) {
      return;
    }

    const formData = ownerObjectUpdater(this.addPortfolioForm.value);

    if (this.type === 'product') {
      this.customEventService.announceEvent(this.mode === 'add' ? ActionTypesEnum.CREATE_PRODUCT : ActionTypesEnum.UPDATE_PRODUCT, formData);
      return;
    }

    this.customEventService.announceEvent(this.mode === 'add' ? ActionTypesEnum.CREATE_COMPONENT : ActionTypesEnum.UPDATE_COMPONENT, formData);
  }

  resetForm(): void {
    this.createForm();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  ngOnDestroy(): void {
    // prevent memory leak when component destroyed
  }
}
